var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailableSpotsRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9774 0.599609H2.02183C1.23961 0.599609 0.599609 1.23961 0.599609 2.02183V11.9774C0.599609 12.7596 1.23961 13.3996 2.02183 13.3996H11.9774C12.7596 13.3996 13.3996 12.7596 13.3996 11.9774V2.02183C13.3996 1.23961 12.7596 0.599609 11.9774 0.599609ZM4.86628 10.5552H3.44405V5.57739H4.86628V10.5552ZM7.71072 10.5552H6.2885V3.44405H7.71072V10.5552ZM10.5552 10.5552H9.13294V7.71072H10.5552V10.5552Z",
    fill: "#D90327"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableSpotsRed);
export default __webpack_public_path__ + "static/media/available-spots-red.060c10828afefcfc877b2059c119f776.svg";
export { ForwardRef as ReactComponent };